import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'phone'})
export class PhonePipe implements PipeTransform
{
    transform(tel, args)
    {
        let newVal = tel.replace(/\D/g, '');

        if (tel.match(/[^0-9]/)) {
            return tel;
        }

        // let country;
        // let city;
        // let number;

        // // switch (value.length) {
        // //     case 10: //  -> C PPP. ###.####
        // //         country = 1;
        // //         city = value.slice(0, 3);
        // //         number = value.slice(3);
        // //         break;
        // //     default:
        // //         return tel;              
        // // }

        // country = 1;
        // city = value.slice(0, 3);
        // number = value.slice(3);

        // if (country == 1) {
        //     country = '';
        // }

        // number = number.slice(0, 3) + '.' + number.slice(3);
        // return ( city + '.' + number).trim();

        if (newVal.length === 0) {
            newVal = '';
          } else if (newVal.length <= 3) {
            newVal = newVal.replace(/^(\d{0,3})/, '$1');
          } else if (newVal.length <= 6) {
            newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '$1.$2');
          } else if (newVal.length <= 10) {
            newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '$1.$2.$3');
          } else {
            newVal = newVal.substring(0, 10);
            newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '$1.$2.$3');
          }
        return newVal;
       // return (country + "." + city + "." + number).trim();
    }
}